import { Decimal } from 'decimal.js';

export const formatAmount = (amount: number | Decimal | null) => {
  if (amount === null) return '';
  const numAmount = new Decimal(amount).toDecimalPlaces(2);

  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
  }).format(numAmount.equals(0) ? 0 : numAmount.toNumber());
};

export const formatDate = (date: Date) => {
  return new Date(date).toLocaleDateString('fr-FR');
};

export const formatDateTime = (date: Date) => {
  const d = new Date(date);
  const datePart = d.toLocaleDateString('fr-FR');
  const timePart = d.toLocaleTimeString('fr-FR', {
    hour: '2-digit',
    minute: '2-digit',
  });
  return `${datePart} à ${timePart}`;
};

export const formatPercentage = (
  percent: number | Decimal | null,
  options?: Intl.NumberFormatOptions,
) => {
  if (percent === null) return '';
  return (
    new Decimal(percent).toNumber().toLocaleString('fr-FR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
      ...options,
    }) + '%'
  );
};
